import React from "react";
import { Link } from "react-router-dom";
import Posts from "../Components/Posts";
import Logged from "../Components/Profile.jsx";
import TryLogin from "../Components/TryLogin";
import UserContext from "../UserContext";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { Loader } from "react-clip-loader";
import "react-clip-loader/dist/index.css";
import SEO from "../Components/SEO";
import SidebarNav from "../Components/navigation/SidebarNav";

// import EditProfile from "../Components/EditProfile";
function Home() {
  const { user, posts, mode, loadPosts, loading, ended } =
    React.useContext(UserContext);
  // setting the theme
  const [dark, setDark] = React.useState(false);
  React.useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  const bottomScrollCallback = () => {
    // console.log("Scrolled to bottom");
    if (!loading && posts.length > 0 && !ended) {
      // console.log("Loading new Posts...");
      loadPosts();
    }
  };

  useBottomScrollListener(bottomScrollCallback, {
    offset: 800,
    debounce: 0,
    triggerOnNoScroll: true,
  });

  return (
    <>
      <SEO title="Home"></SEO>
      <div
        className={(dark && "darkmode") + "px-5 flex justify-center w-full"}
        id="posts__container"
      >
        <div className="px-2 grid grid-cols-1 lg:grid-cols-11 lg:w-3/4 lg:gap-10">
          <div className="lg:col-span-6 lg:grid grid-cols-7">
            <div className="top-0 sticky col-span-1 lg:h-screen">
              <div className="hidden lg:block">
              <SidebarNav />
              </div>
            </div>
            <div className="col-span-6">
              {user.token ? (
                <>
                  {posts.map((post) => {
                    return <Posts key={post._id} data={post} />;
                  })}
                  {posts.length > 0 && (
                    <div
                      className={`w-full flex justify-center mb-3 ${
                        dark ? "divbg-in-darkmode" : ""
                      }`}
                    >
                      {loading ? (
                        <Loader
                          small={true}
                          color={"#f80302"}
                          secondaryColor={dark ? "#ffffff" : "#e5e5e5"}
                        />
                      ) : (
                        <Link
                          to="#"
                          className="bg-fire text-white p-3 rounded hover:opacity-50 hover:text-white"
                          onClick={() => !loading && loadPosts()}
                        >
                          {loading ? "Loading..." : "Load More"}
                        </Link>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <div>
                  {posts.length > 0 ? (
                    <Posts data={posts[0]} />
                  ) : (
                    <Posts data={posts[0]} />
                    // <Posts data={{}} />
                  )}
                  <div className="w-full flex justify-center">
                    <Link
                      to="/login"
                      className="bg-fire text-white p-3 rounded hover:opacity-50 hover:text-white"
                    >
                      View More
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="lg:col-span-5">
            {user.token ? <Logged /> : <TryLogin />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
